import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tags, Tag, ChevronRight } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { PageTitle, PageSubtitle, Loader, EmptyState, Card } from "@/components/common";
import { cn } from "@/lib/utils";

const META = {
  pending: { label: "In attesa", tone: "text-[hsl(var(--warning))]", dot: "bg-[hsl(var(--warning))]" },
  accepted: { label: "Accettata", tone: "text-[hsl(var(--success))]", dot: "bg-[hsl(var(--success))]" },
  rejected: { label: "Rifiutata", tone: "text-destructive", dot: "bg-destructive" },
  withdrawn: { label: "Ritirata", tone: "text-muted-foreground", dot: "bg-muted-foreground" },
};
function dt(v) {
  return new Date(v).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export default function OffersHistoryPage() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    apiFetch("/offers/history").then(setOffers).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-3">
      <PageTitle>Storico proposte</PageTitle>
      <PageSubtitle>Tutte le controproposte di prezzo ricevute dai vettori, con l'esito della trattativa.</PageSubtitle>
      {loading ? (
        <Loader />
      ) : offers.length === 0 ? (
        <EmptyState icon={Tags} title="Nessuna proposta ricevuta" text="Quando un vettore propone un prezzo per un tuo viaggio, la trattativa resta registrata qui." />
      ) : (
        offers.map((o) => {
          const meta = META[o.status] || META.pending;
          return (
            <Link key={o.id} to={`/trip/${o.trip_id}`} data-testid={`history-offer-${o.id}`}>
              <Card className="space-y-3 hover:shadow-md">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary">
                    <Tag className="h-5 w-5 text-primary" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate font-extrabold text-foreground">{o.carrier_name}</p>
                    <p className="truncate text-xs text-muted-foreground">{o.pickup} → {o.delivery}{o.date ? ` · ${o.date}` : ""}</p>
                    <p className="text-xs text-muted-foreground">{dt(o.created_at)}</p>
                  </div>
                  <span className="text-lg font-extrabold text-primary">€ {o.price}</span>
                </div>
                <div className="flex items-center justify-between border-t border-border pt-2.5">
                  <span className="inline-flex items-center gap-2 rounded-full bg-secondary/60 px-3 py-1.5">
                    <span className={cn("h-2 w-2 rounded-full", meta.dot)} />
                    <span className={cn("text-xs font-extrabold", meta.tone)}>{meta.label}</span>
                  </span>
                  <ChevronRight className="h-4 w-4 text-muted-foreground" />
                </div>
              </Card>
            </Link>
          );
        })
      )}
    </div>
  );
}
